var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "callout",
        {
          attrs: { "class-panel": "bg-transparent", "has-border": false },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm._l(_vm.dispenseRequestList, function(item, index) {
                    return _c(
                      "callout",
                      {
                        key: `dispenseRequestList_${index}`,
                        attrs: { "class-main": "my-1", "has-toggle": false }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Número Seguro Social:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.specialistSsn))
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Nombre:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.specialistFullName))
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Matrícula Activa:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.corpServiceTotal))
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  _vm.dispenseRequestList.length === 0
                    ? _c(
                        "callout",
                        {
                          attrs: { "class-main": "mt-1", "has-toggle": false }
                        },
                        [
                          _c("div", { staticClass: "left-border-none" }),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm d-flex justify-content-center text-gray pt-3"
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    " No cuenta con Solicitud de Dispensa "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("icon", {
                    attrs: { i: "fas fa-address-book font-14 mr-2" }
                  }),
                  _c("span", [_vm._v("Solicitud de Dispensa")])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-sm-6" }),
            _c("div", { staticClass: "col-sm d-flex mr-2" }, [
              _c(
                "p",
                { staticClass: "mr-5 font-15 font-weight-normal top-1" },
                [
                  _vm._v(" Total Matrícula Activa: "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.serviceTotal))
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _c(
        "callout",
        {
          attrs: {
            "class-main": "mt-2",
            "class-panel": "bg-transparent",
            "has-border": false
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm._l(_vm.supervisedOtherCorporationList, function(
                    item,
                    index
                  ) {
                    return _c(
                      "callout",
                      {
                        key: `supervisedOtherCorporationList_${index}`,
                        attrs: { "class-main": "mt-1", "has-toggle": false }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Número Seguro Social:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.specialistSsn))
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Nombre:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.specialistFullName))
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Corporación:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(" " + _vm._s(item.companyName) + " ")
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("span", { staticClass: "data-name" }, [
                              _vm._v("Total Matrícula Activa:")
                            ]),
                            _c("p", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.serviceTotal))
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  _vm.supervisedOtherCorporationList.length === 0
                    ? _c(
                        "callout",
                        {
                          attrs: { "class-main": "mt-1", "has-toggle": false }
                        },
                        [
                          _c("div", { staticClass: "left-border-none" }),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm d-flex justify-content-center text-gray pt-3"
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    " No cuenta con Supervisados en Otra Corporación "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("icon", {
                    attrs: { i: "fas fa-address-book font-14 mr-2" }
                  }),
                  _c("span", [_vm._v("Supervisados en Otra Corporación")])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-sm-6" }),
            _c("div", { staticClass: "col-sm d-flex mr-2" }, [
              _c(
                "p",
                { staticClass: "mr-5 font-weight-normal font-15 top-1" },
                [
                  _vm._v(" Total Matrícula Activa: "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.otherCorporationTotal))
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }